import { FrameName } from "../config";
import ShallowSeaFishingBoatBuildingTileEntity from "./ShallowSeaFishingBoatBuildingTileEntity";

class DeepSeaBigFishingBoatBuildingTileEntity extends ShallowSeaFishingBoatBuildingTileEntity {
	public static readonly frameName = FrameName.DEEP_SEA_BIG_FISHING_BOAT;
}

export default DeepSeaBigFishingBoatBuildingTileEntity;
